import React from 'react';
import { Divider, Grid, Skeleton, SxProps } from '@mui/material';

interface ICandidateApplicationsActivityDetailsSkeleton {
  dataCount?: number;
  rowCount?: number;
  skeletonGridSxProps?: SxProps;
  defaultGrid?: boolean;
  skeletonAutoGridSxProps?: SxProps;
}

export const CandidateApplicationsActivityDetailsSkeleton: React.FC<
  ICandidateApplicationsActivityDetailsSkeleton
> = ({
  dataCount = 2,
  rowCount = 2,
  skeletonGridSxProps,
  skeletonAutoGridSxProps,
  defaultGrid = true,
}) => {
  return (
    <>
      {[...Array(dataCount)]?.map((_, j: number) => (
        <Grid key={`shimmer-container-${j}`} container direction={'row'}>
          {[...Array(rowCount)].map((__, i: number) => (
            <Grid
              item
              key={`shimmer-${i}-${j}`}
              sm={12}
              md={defaultGrid ? (i ? 5 : 7) : 12 / rowCount}
              data-testid={`shimmer-${i}-${j}`}
              sx={{ pr: '1rem' }}
            >
              <Grid container direction={'row'}>
                {[1, 2].map((___, k: number) => (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    key={`shimmer-${i}-${k}`}
                    sx={{
                      mb: { sm: '0.5rem' },
                      ...(dataCount === j + 1
                        ? skeletonAutoGridSxProps
                        : skeletonGridSxProps),
                    }}
                  >
                    <Skeleton
                      sx={{
                        borderRadius: '0.5rem',
                        bgcolor: (theme) => theme.palette.neutral?.main,
                      }}
                      variant='rectangular'
                      height={24}
                      width={k ? (j ? '80%' : '60%') : '95%'}
                      animation='wave'
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ))}
        </Grid>
      ))}
    </>
  );
};

interface ICandidateApplicationsFormSkeleton {
  sx?: SxProps;
  count?: number;
  rowCount?: number;
  skeletonGridSxProps?: SxProps;
  defaultGrid?: boolean;
}

export const CandidateApplicationsFormSkeleton: React.FC<
  ICandidateApplicationsFormSkeleton
> = ({ sx, count = 2, rowCount = 2, defaultGrid }) => {
  return (
    <Grid>
      <Grid container sx={{ my: '0.5rem', ...sx }}>
        <Skeleton
          sx={{
            borderRadius: '0.5rem',
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
          variant='rectangular'
          height={28}
          width={'30%'}
          animation='wave'
        />
      </Grid>
      {[...Array(count)].map((_, i) => (
        <CandidateApplicationsActivityDetailsSkeleton
          defaultGrid={defaultGrid}
          skeletonAutoGridSxProps={count === i + 1 ? { mb: 0 } : {}}
          rowCount={rowCount}
          key={`shimmer${i}`}
          dataCount={2}
        />
      ))}
    </Grid>
  );
};

export const CandidateApplicationsActivitySkeleton = () => {
  return (
    <Grid
      id='candidate-applications-activity-schimmer'
      data-testid='candidate-applications-activity-schimmer'
      container
      direction={'column'}
    >
      <Grid container sx={{ my: '0.5rem', mb: '1rem' }}>
        <Skeleton
          sx={{
            borderRadius: '0.5rem',
            bgcolor: (theme) => theme.palette.neutral?.main,
          }}
          variant='rectangular'
          height={28}
          width={'30%'}
          animation='wave'
        />
      </Grid>
      <CandidateApplicationsActivityDetailsSkeleton
        rowCount={2}
        dataCount={2}
      />
      <Divider
        sx={{
          my: '1.25rem',
        }}
      />
      <CandidateApplicationsFormSkeleton />
    </Grid>
  );
};
